import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../../console/store/useAuthStore";
import { enum_api_uri } from "../../utils/enum";

interface GetBranchResponse {
    branch_idx: number;
    branch_option: string;
    var_sid: string;
}

export const useGetOrderBranchOption = (customerBranchIdx?: number | null): UseQueryResult<GetBranchResponse[], Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    return useQuery<GetBranchResponse[], Error>({
        queryKey: ["getOrderBranchOption", customerBranchIdx],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_order_branch_option}/${customerBranchIdx}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
        enabled: customerBranchIdx !== 0,
    });
};
